import { createContext, Dispatch, ReactNode, SetStateAction, useMemo, useState } from 'react';

type Props = {
  children: ReactNode;
};

type CompetitorTypeContext = [string, Dispatch<SetStateAction<string>>];

export const CompetitorTypeContext = createContext<CompetitorTypeContext | undefined>(undefined);

export const CompetitorTypeProvider = ({ children }: Props): JSX.Element => {
  const [competitorsType, setCompetitorsType] = useState<string>('Team');
  const contextValue: CompetitorTypeContext = useMemo(
    () => [competitorsType, setCompetitorsType],
    [competitorsType, setCompetitorsType],
  );

  return (
    <CompetitorTypeContext.Provider value={contextValue}>{children}</CompetitorTypeContext.Provider>
  );
};
